const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export const getBlob = async file => {
  const fileUri = toBase64(file);
  const resp = await fetch(fileUri);
  const imageBody = await resp.blob();
  return imageBody;
};

export const uploadImage = async (uploadUrl, data) => {
  const imageBody = await getBlob(data);
  return fetch(uploadUrl, {
    method: 'PUT',
    body: imageBody,
    headers: {
      'Content-Type': 'image/jpeg'
    }
  });
};
